<template>
    <div v-if="currentBase">
        <AdaptersDropdown
            v-model="currentBase"
            :options="bases"
            optionLabel="caption"
            @change="onChangeDatabase"
            filter
            class="report_base__input"
            :resetFilterOnHide="true"
            :hoverUsage="true"
            ref="input"
            append-to="body"
        >
            <template #value="slotProps">
                <div v-if="slotProps.value" class="flex align-items-center gap-2">
                    <img :alt="slotProps.value.caption" :src="getEngineIcon(slotProps.value.engine)" />
                    <span class="text-sm line-height-1">{{ slotProps.value.short }}</span>
                    <i class="fa fa-caret-down ml-1"></i>
                </div>
                <span v-else>
                    {{ slotProps.placeholder }}
                </span>
            </template>
            <template #filtericon>
                <i class="pi pi-search" />
            </template>
        </AdaptersDropdown>
    </div>
</template>

<script>
import AdaptersDropdown from "./adapters/Dropdown.vue";
import {ArrayHelper} from "../helpers/ArrayHelper";
import {BaseEngineIcons} from "../constants/baseEngineIcons";
import {Listeners} from "../constants/listeners";

export default {
    name: "ReportBase",
    props: {
        backgroundColor: {
            type: String,
            required: false,
            default: '#eee'
        },
    },
    data() {
        return {
            bases: this.$tm('lang.main.bases'),
            currentBase: null,
        }
    },
    created() {
        this.$emitter.on(Listeners.GLOBAL_STORE_GET_DATABASE, database => this.setDatabase(database));
    },
    methods: {
        setDatabase(database) {
            this.currentBase = ArrayHelper.getObjectByAttrValue(this.bases, 'name', database.dbname);
        },
        onChangeDatabase(e) {
            let database = e.value;
            database.dbname = database.name;
            database.sename = database.engine;
            this.$store.commit('SET_DATABASE', database);
            this.$emitter.emit(Listeners.CONTENT_PRELOADER_SHOW);

            window.location.href = sprintf(
                '/%s/changedb/%s?url=%s',
                window.locale,
                database.dbname,
                window.app_current_page
            );
        },
        getEngineIcon(engine) {
            return BaseEngineIcons[engine];
        },
    },
    components: {
        AdaptersDropdown
    },
}
</script>

<style scoped>
.report_base__input:deep(.p-dropdown-trigger) {
    display: none;
}
.report_base__input {
    border: 1px solid v-bind(backgroundColor);
    background-color: v-bind(backgroundColor);
}
.report_base__input:hover {
    border-color: v-bind(backgroundColor);
}
.report_base__input div,
.report_base__input .fa {
    color: var(--text-color-secondary);
}
.report_base__input img {
    max-height: 1rem;
    border-radius: 50%;
}
.report_base__input i::before {
    position: static;
}
.report_base__input:deep(.p-dropdown-label) {
    padding: 10px 20px;
}
</style>
